import { render, staticRenderFns } from "./training_manager.vue?vue&type=template&id=0d6970bc&scoped=true&"
import script from "./training_manager.vue?vue&type=script&lang=js&"
export * from "./training_manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6970bc",
  null
  
)

export default component.exports